/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Csv_Import_UnmatchedInputs */



/**
* | output |
* | --- |
* | "{count} row(s) not matched to a member:" |
*
* @param {Csv_Import_UnmatchedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_unmatched = /** @type {((inputs: Csv_Import_UnmatchedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_UnmatchedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} ligne(s) non associée(s) à un membre :`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} fila(s) no asociada(s) a un miembro:`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} linha(s) não associada(s) a um membro:`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} riga/e non associata/e a un membro:`)
	return /** @type {LocalizedString} */ (`${i?.count} row(s) not matched to a member:`)
});